import config from "../config";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";

class DetailTrackingStore {
  total = 0;
  loading = false;
  trackData = [];
  totalVehicalState = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      trackData: observable,
      loading: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    status,
    driver,
    vehicleNo,
    searchField,
    isadmin,
    userCompany,
  }) {
    // this.loading = true;
    // var postData = {
    //   tokenId: "",
    //   searchField: searchField,
    //   companyId: companyId,
    //   isadmin: isadmin,
    //   userCompany: userCompany,
    //   offset: offset,
    //   limit: limit,
    //   status: status,
    // };
    // const base64Input = await utf8.encode(JSON.stringify(postData));
    // const base2 = JSON.stringify(base64_encode(base64Input));

    // // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicletracking&a=detailtrackdata",
    //     "postData=" + base2
    //   );
    // var liveTrackingData = response?.data?.data?.detailtrack;

    // // console.log(response?.data?.data?.detailtrack, "vehicle");
    // Object.keys(liveTrackingData).map((e, i) => {
    //   let r = liveTrackingData[i];
    //   // console.log(r)
    //   let defaultImage = "";
    //   //  var diff = new Date(r.currtime) - new Date(r.updatedate);
    //   const diff = moment(r.currtime).diff(r.updatedate, "minutes");
    //   var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
    //   if (diff >= 90) {
    //     liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
    //     liveTrackingData[i].rowBackground = "gray";
    //     liveTrackingData[i].currentStatus = "nodata";
    //     defaultImage = "default-gray.png";
    //   } else if (r.acc == 1 && r.speed == 0) {
    //     //idle)
    //     liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
    //     liveTrackingData[i].rowBackground = "yellow";
    //     liveTrackingData[i].currentStatus = "idle";
    //     defaultImage = "default-yellow.png";
    //   } else if (r.acc == 0 || r.acc == 'NAA' || r.acc == 'NA' || r.acc===null) {
    //     liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
    //     liveTrackingData[i].rowBackground = "red";
    //     liveTrackingData[i].currentStatus = "stop";
    //     defaultImage = "default-red.png";
    //   } else if (r.acc == 1 && r.speed > 0) {
    //     liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
    //     liveTrackingData[i].rowBackground = "green";
    //     liveTrackingData[i].currentStatus = "running";
    //     defaultImage = "default-green.png";
    //   }
    //   liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

    //   try {
    //     require("../assets/images/detailtracking/" +
    //       liveTrackingData[i].listImage);
    //   } catch (err) {
    //     liveTrackingData[i].listImage = defaultImage;
    //   }

    //   try {
    //     require("../assets/images/livetracking/" +
    //       liveTrackingData[i].mapImage);
    //   } catch (err) {
    //     // console.log(defaultImage)
    //     // liveTrackingData[i].mapImage = "car-icon-blue.png";
    //     liveTrackingData[i].mapImage = defaultImage
    //     // liveTrackingData[i].listImage =defaultImage
    //   }
    // });
    // this.trackData = liveTrackingData;
    // this.totalVehicalState = response?.data?.data?.totalvehstate;
    // this.loading = false;

    // this.total = parseInt(response?.data?.data?.TotalCount);
    // // console.log(this.total, "total");

    this.loading = true;
    var postData = {
      tokenId: "",
      searchField: searchField,
      companyId: companyId,
      isadmin: isadmin,
      userCompany: userCompany,
      offset: offset,
      limit: limit,
      status: status,
      project: config.project,
    }; //
    var response = await postApi
      .getClient("")
      // .get('http://localhost:3053' + "/DetailTracking/getDetailtrackData", {
      .get(config.NodeUrl + "/DetailTracking/getDetailtrackData", {
        //  .get('http://localhost:3046' + "/DetailTracking/getDetailtrackData", {
        params: postData,
      });
    //console.log(response.data?.data?.detailtrack, "vehicle");

    var liveTrackingData = response.data?.data?.detailtrack;
    let finalLiveTrackingData = await this.handleVehicleImage(liveTrackingData);

    // Object.keys(liveTrackingData).map((e, i) => {
    //   let r = liveTrackingData[i];
    //   let defaultImage = "car-icon-blue.png";
    //   const diff = moment(r.currtime).diff(r.updatedate, "minutes");
    //   var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
    //   console.log(vehicleTypeNew, "vehicleTypeNew");
    //   if (config.project === "starlingeye") {
    //     if (diff > 60 && diff <= 1440) {
    //       liveTrackingData.listImage = vehicleTypeNew + "-purple.png";
    //       liveTrackingData.rowBackground = "purple";
    //       liveTrackingData.currentStatus = "unavailing";
    //       defaultImage = "default-purple.png";
    //     } else if (diff > 1440 && diff <= 2880) {
    //       liveTrackingData.listImage = vehicleTypeNew + "-gray.png";
    //       liveTrackingData.rowBackground = "gray";
    //       liveTrackingData.currentStatus = "unavailing24_48";
    //       defaultImage = "default-gray.png";
    //     } else if (diff > 2880) {
    //       liveTrackingData.listImage = vehicleTypeNew + "-black.png";
    //       liveTrackingData.rowBackground = "black";
    //       liveTrackingData.currentStatus = "nodata";
    //       defaultImage = "default-black.png";
    //     } else if (r.acc === 1 && r.speed == 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
    //       liveTrackingData[i].rowBackground = "yellow";
    //       liveTrackingData[i].currentStatus = "idle";
    //       defaultImage = "default-yellow.png";
    //     } else if (r.acc == 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
    //       liveTrackingData[i].rowBackground = "red";
    //       liveTrackingData[i].currentStatus = "stop";
    //       defaultImage = "default-red.png";
    //     } else if (r.acc == 1 && r.speed > 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
    //       liveTrackingData[i].rowBackground = "green";
    //       liveTrackingData[i].currentStatus = "running";
    //       defaultImage = "default-green.png";
    //     }
    //   } else {
    //     if (diff >= 90) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
    //       liveTrackingData[i].rowBackground = "gray";
    //       liveTrackingData[i].currentStatus = "nodata";
    //       defaultImage = "default-gray.png";
    //     } else if (r.acc === 1 && r.speed == 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
    //       liveTrackingData[i].rowBackground = "yellow";
    //       liveTrackingData[i].currentStatus = "idle";
    //       defaultImage = "default-yellow.png";
    //     } else if (r.acc == 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
    //       liveTrackingData[i].rowBackground = "red";
    //       liveTrackingData[i].currentStatus = "stop";
    //       defaultImage = "default-red.png";
    //     } else if (r.acc == 1 && r.speed > 0) {
    //       liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
    //       liveTrackingData[i].rowBackground = "green";
    //       liveTrackingData[i].currentStatus = "running";
    //       defaultImage = "default-green.png";
    //     }
    //   }

    //   liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

    //   try {
    //     require("../assets/images/detailtracking/" +
    //       liveTrackingData[i].listImage);
    //   } catch (err) {
    //     liveTrackingData[i].listImage = defaultImage;
    //   }

    //   try {
    //     require("../assets/images/livetracking/" +
    //       liveTrackingData[i].mapImage);
    //   } catch (err) {
    //     liveTrackingData[i].mapImage = defaultImage;
    //   }
    //   console.log(liveTrackingData[i].mapImage);
    // });

    this.trackData = finalLiveTrackingData;
    this.totalVehicalState = response?.data?.data?.totalvehstate;
    this.loading = false;

    this.total = parseInt(response?.data?.data?.TotalCount);
  }

  async handleVehicleImage(data) {
    let liveTrackingData = data;

    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew2 = "vehicle";
      var distanceUnit = "Km";
      var speedUnit = "Km/h";

      if (r.vehicleTypeNew === "Yatch") {
        vehicleTypeNew2 = "fleet";
        distanceUnit = "NM";
        speedUnit = "Kt";
      }
      r.vehicleTypeNew2 = vehicleTypeNew2;
      r.distanceUnit = distanceUnit;
      r.speedUnit = speedUnit;

      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (config.project == "securetrack" && parseInt(r.nonReport) == 1) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "Non Report";
        defaultImage = "default-gray.png";

      } else if (config.project == "starlingeye" && diff > 60 && diff <= 1440) {
        // Above 1 hour to 24 hours
        liveTrackingData[i].listImage = vehicleTypeNew + "-purple.png";
        liveTrackingData[i].rowBackground = "purple";
        liveTrackingData[i].currentStatus = "Unavailing";
        defaultImage = "default-purple.png";
      } else if (
        config.project == "starlingeye" &&
        diff > 1440 &&
        diff <= 2880
      ) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "Unavailing 24 to 48 hours";
        defaultImage = "default-gray.png";
      } else if (config.project == "starlingeye" && diff >= 2880) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-black.png";
        liveTrackingData[i].rowBackground = "black";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-black.png";
      } else if (diff >= 90) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No data";
        defaultImage = "default-gray.png";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.acc == 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.acc == null || (r.acc == 1 && r.speed > 0)) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }

  async exportExcel(postData) {
    var detailTrackData = { postData };
    try {
      var response = await postApi
        .getClient("")
        .post(
          config.NodeUrl + "/DetailTracking/exportDetailTrackingData",
          detailTrackData,
          {
            responseType: "blob",
          }
        );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Detail_Tracking_Excel.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default DetailTrackingStore;
